module.exports = __webpack_public_path__ + "img/logo.25beff94.jpg";